$(function(){
  $('.u_pro_size_var_inner').click(function(){
    let var_id = $(this).attr('data-id');
    $('.u_pro_size_var_inner').removeClass('activevar')
    $(this).addClass('activevar')
    $('.u_pro_var_id').attr('value',var_id)
     // variant change price
          var variant_price = $(this).attr('data-price');
          console.log('variant price',variant_price,Shopify.formatMoney(variant_price).replace('.',',').replace('$','€'));
          $('.ProductMeta__Price ').text(Shopify.formatMoney(variant_price).replace('.',',').replace('$','€'));
        history.pushState({}, '','?variant='+var_id);
  })
  $('.activevar').trigger('click')
})